<template>
  <div class="checkbox">
    <input
      type="checkbox"
      v-bind="$attrs"
      v-on="$listeners"
      class="checkbox-input absolute opacity-0"
    />
    <label
      :for="$attrs.id"
      class="checkbox-label cursor-pointer select-none relative block pl-12"
      :class="{
        'opacity-50 pointer-events-none': $attrs.disabled,
      }"
    >
      <slot />
    </label>
  </div>
</template>

<script>
export default {
  inheritAttrs: false,
};
</script>

<style lang="scss" scoped>
.checkbox-label {
  &::before,
  &::after {
    content: '';
    position: absolute;
    display: block;
  }
  &::before {
    width: 2rem;
    height: 2rem;
    left: 0;
    top: 0;
    background-color: white;
    border-radius: 0.5rem;
  }
  &::after {
    width: 1.2rem;
    height: 1.2rem;
    left: 0.4rem;
    top: 0.4rem;
    background-color: #56a34d;
    border-radius: 0.3rem;
    opacity: 0;
    transition: opacity 0.1s;
  }
}
.checkbox-input:checked + .checkbox-label::after {
  opacity: 1;
}
</style>
